<template>
    <div class="card card-default shadow">
        <div class="card-body">
            <div class="row">

                <div class="col-md-6" v-for="item in dairy">
                    <h4>{{item.Date}}</h4>
                    <table class=" table table-bordered table-sm" v-for="(i,index) in item.child">
                        <thead class="bg-custom">
                            <tr>
                              <th>{{i.CourseName}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>Heading/Topic/Title: </b>{{i.Heading}}</td>
                            </tr>
                            <tr>
                                <td><b>Class Work: </b> <br />{{i.Content}}</td>
                            </tr>
                            <tr>
                                <td><b>Home Work: </b> <br />{{i.HomeWork}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>import axios from 'axios';
    export default {
        name: 'fee',
        data() {
            return {
                dairy: [],
            }
        },
        created() {
            this.getTasks();
        },
        updated() {
        },

        methods: {
            getTasks: function () {
                var vm = this;
                axios.post('/api/PortalApi/loadDailyDairy')
                    .then(function (response) {
                        vm.dairy = response.data.final;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        }
    }</script>


// WEBPACK FOOTER //
// src/components/school/LMS/dailyDairy.vue